import {
  MessageRecord,
  MessageRecordPlaceholder,
  MessageRecordType,
} from '../../../../../../../../server-services/query-records/room-records';
import { WorkspaceSubscriptionDialogueMessageEventRecord } from '../../../../../../../../server-services/query-records/workspace-records';
import { dialogueMessagesQuery } from '../../../../../../../../server-services/querys';
import { WorkspaceChangeSubscriptionSpecificHandler } from '../types';

export let onCreateDialogueMessageEventSubscriptionHandler: WorkspaceChangeSubscriptionSpecificHandler =
  (cache, event: WorkspaceSubscriptionDialogueMessageEventRecord) => {
    let msg: MessageRecord = {
      id: event.messageId,
      posterId: event.posterId,
      content: <string>event.content,
      edited: <boolean>event.edited,
      reactions: {},
    };

    if (event.replyTo) {
      msg.replyTo = event.replyTo;
    }

    if (event.decryptionError) {
      msg.decryptionError = event.decryptionError;
      msg.decryptionErrorMessage = event.decryptionErrorMessage;
    }

    let messages: (MessageRecordPlaceholder | MessageRecord)[] = cache.getCacheDataByRequest({
      query: dialogueMessagesQuery,
      variables: {
        peerId: event.id,
      },
    });

    if (!messages) {
      messages = [
        { type: MessageRecordType.END },
        { type: MessageRecordType.VOID },
        { type: MessageRecordType.END },
      ];
      cache.setCacheDataByRequest(
        {
          query: dialogueMessagesQuery,
          variables: {
            peerId: event.id,
          },
        },
        messages
      );
    }

    if (!messages.find((message) => (<MessageRecord>message)?.id === msg.id)) {
      const splice_index = 1;
      messages.splice(splice_index, 0, msg);
      if (messages[splice_index + 1]['type'] === MessageRecordType.VOID) {
        messages[splice_index + 1]['beforeMsgId'] = msg.id;
      }
    }
    // else {}

    if (!cache.getCacheData('messages')[event.id]) {
      cache.getCacheData('messages')[event.id] = {};
    }
    cache.getCacheData('messages')[event.id][msg.id] = msg;
  };
